<template>
  <div v-if="form && model">
    <rkm-area no-margin-top title="filtros" type="fieldset">
      <rkm-form ref="RkmForm" show-legend>
        <rkm-row>
          <rkm-col cols="2">
            <rkm-form-date-picker
              label="Data inicial"
              v-model="model.dataInicial"
              @input="getVeiculos"
              :validations="{ required: true }"
            />
          </rkm-col>
          <rkm-col cols="2">
            <rkm-form-date-picker
              label="Data final"
              v-model="model.dataFinal"
              @input="getVeiculos"
              :validations="{ required: true }"
              :min-date="model.dataInicial"
            />
          </rkm-col>

          <rkm-col cols="4">
            <rkm-form-select
              show-default-option
              default-option-text="TODOS"
              :options="form.veiculos"
              label="Veículo"
              text-field="identificacaoVeiculo"
              value-field="id"
              v-model="model.veiculo"
              @change="getMotoristas"
            />
          </rkm-col>

          <rkm-col cols="4">
            <rkm-form-select
              show-default-option
              default-option-text="TODOS"
              :options="form.motoristas"
              label="Motorista"
              text-field="nome"
              value-field="id"
              v-model="model.motorista"
              @change="getDestinos"
            />
          </rkm-col>
        </rkm-row>

        <rkm-row>
          <rkm-col cols="4">
            <rkm-form-select
              show-default-option
              default-option-text="TODOS"
              :options="form.destinos"
              label="Destino"
              text-field="descricao"
              value-field="id"
              v-model="model.destino"
            />
          </rkm-col>

          <rkm-col>
            <rkm-button color="primary" :label="false" @click="search">
              Buscar
            </rkm-button>
            <rkm-button :label="false" @click="reset"> Limpar </rkm-button>
          </rkm-col>
        </rkm-row>
      </rkm-form>
    </rkm-area>

    <rkm-area no-margin-top title="Resultado" v-if="mostraAreas">
      <template v-slot:trailing>
        <rkm-dropdown
          class="mr-2"
          color="primary"
          cols="1"
          menu-class="auto-scroll"
          no-caret
          small
          title="Colunas"
          v-rkm-tooltip.hover
        >
          <template v-slot:button-content>
            <rkm-icon icon="columns" />
          </template>

          <rkm-form-checkbox
            :indeterminate="indeterminate"
            @change="selectAll"
            class="mx-2"
            v-model="selectedAll"
          >
            Todas
          </rkm-form-checkbox>

          <rkm-form-checkbox-group
            :options="optionalColumns"
            class="mx-2"
            stacked
            text-field="label"
            v-model="selectedCols"
            value-field="key"
          />
        </rkm-dropdown>

        <rkm-button
          :disabled="items.length === 0"
          @click="print"
          color="info"
          small
          title="Imprimir"
        >
          <rkm-icon icon="print" />
        </rkm-button>

        <rkm-button
          :disabled="items.length === 0"
          @click="exportTo"
          color="info"
          small
          title="Exportar"
        >
          <rkm-icon icon="file-export" />
        </rkm-button>
      </template>

      <rkm-table
        :fields="fields"
        :items="items"
        no-footer-sorting
        sort-by="horaAgendamento"
      >
      </rkm-table>
    </rkm-area>

    <rkm-area title="Totais" type="fieldset" no-margin-top v-if="mostraAreas">
      <rkm-row>
        <rkm-col col="auto">
          Diária
          <rkm-alert color="secondary">
            <strong>
              {{ formatarBRL(totalizadores.totalDiaria) }}
            </strong>
          </rkm-alert>
        </rkm-col>

        <rkm-col col="auto">
          Refeição
          <rkm-alert color="secondary">
            <strong>
              {{ formatarBRL(totalizadores.totalRefeicao) }}
            </strong>
          </rkm-alert>
        </rkm-col>

        <rkm-col col="auto">
          Pernoite
          <rkm-alert color="secondary">
            <strong>
              {{ formatarBRL(totalizadores.totalPernoite) }}
            </strong>
          </rkm-alert>
        </rkm-col>

        <rkm-col col="auto">
          Pedágio
          <rkm-alert color="secondary">
            <strong>
              {{ formatarBRL(totalizadores.totalPedagio) }}
            </strong>
          </rkm-alert>
        </rkm-col>

        <rkm-col col="auto">
          Combustível
          <rkm-alert color="secondary">
            <strong>
              {{ formatarBRL(totalizadores.totalCombustivel) }}
            </strong>
          </rkm-alert>
        </rkm-col>

        <rkm-col col="auto">
          Outras despesas
          <rkm-alert color="secondary">
            <strong>
              {{ formatarBRL(totalizadores.totalOutrasDespesas) }}
            </strong>
          </rkm-alert>
        </rkm-col>

        <rkm-col col="auto">
          Despesa geral
          <rkm-alert color="secondary">
            <strong>
              {{ formatarBRL(totalizadores.totalDespesa) }}
            </strong>
          </rkm-alert>
        </rkm-col>
      </rkm-row>
    </rkm-area>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { repository, error, data, object, stringCase, file } from "@/mixins";
import moment from "moment";

export default {
  computed: {
    optionalColumns() {
      return this.columns.filter((c) => !(c.fixed || false));
    },
    fields() {
      return this.columns.filter(
        (c) => c.fixed || false || this.selectedCols.includes(c.key)
      );
    },
  },
  created() {
    this.repositories = {
      relatorioPrestacaoConta: this.getConectaSusRepository(
        "transportePaciente.relatorioPrestacaoConta"
      ),
      impressao: this.getConectaSusRepository("impressao.transportePaciente"),
      exportacao: this.getConectaSusRepository("exportacao.transportePaciente"),
    };
    this.load();
  },
  data() {
    return {
      form: null,
      model: null,
      items: [],
      selectedAll: false,
      indeterminate: true,
      mostraAreas: false,
      totalizadores: [],
      selectedCols: ["kmSaida", "kmChegada"],
      columns: [
        {
          key: "dataHorarioPartida",
          label: "Data/hora saída",
          formatter: (value) => this.verificaDadoNulo(value),
          sortable: true,
          fixed: true,
        },
        {
          key: "dataHorarioChegada",
          label: "Data/hora chegada",
          formatter: (value) => this.verificaDadoNulo(value),
          sortable: true,
          fixed: true,
        },
        {
          key: "identificacaoVeiculo",
          label: "Veículo",
          formatter: (value) => this.verificaDadoNulo(value),
          sortable: true,
          fixed: true,
        },
        {
          key: "motorista",
          label: "Motorista",
          formatter: (value) => this.verificaDadoNulo(value),
          sortable: true,
          fixed: true,
        },
        {
          key: "destino",
          label: "Destino",
          formatter: (value) => this.verificaDadoNulo(value),
          sortable: true,
          fixed: true,
        },
        {
          key: "kmSaida",
          label: "KM de saída",
          formatter: (value) => this.verificaDadoNulo(value),
          sortable: true,
        },
        {
          key: "kmChegada",
          label: "KM de chegada",
          formatter: (value) => this.verificaDadoNulo(value),
          sortable: true,
        },
        {
          key: "diaria",
          label: "Diária",
          formatter: (value) => this.formatarBRL(value),
          isCurrency: true,
          sortable: true,
        },
        {
          key: "refeicao",
          label: "Refeição",
          formatter: (value) => this.formatarBRL(value),
          isCurrency: true,
          sortable: true,
        },
        {
          key: "pernoite",
          label: "Pernoite",
          formatter: (value) => this.formatarBRL(value),
          isCurrency: true,
          sortable: true,
        },
        {
          key: "pedagio",
          label: "Pedágio",
          formatter: (value) => this.formatarBRL(value),
          isCurrency: true,
          sortable: true,
        },
        {
          key: "combustivel",
          label: "Combustível",
          formatter: (value) => this.formatarBRL(value),
          isCurrency: true,
          sortable: true,
        },
        {
          key: "outrasDespesas",
          label: "Outras despesas",
          formatter: (value) => this.formatarBRL(value),
          isCurrency: true,
          sortable: true,
        },
        {
          key: "descricaoOutrasDespesas",
          label: "Descrição outras despesas",
          formatter: (value) => this.verificaDadoNulo(value),
          sortable: true,
        },
        {
          key: "totalDespesa",
          label: "Total",
          formatter: (value) => this.formatarBRL(value),
          isCurrency: true,
          sortable: true,
          fixed: true,
        },
      ],
    };
  },
  methods: {
    ...mapActions(["setLoading", "unsetLoading"]),
    load() {
      this.setLoading();
      this.repositories.relatorioPrestacaoConta
        .index()
        .then(({ data }) => {
          if (data.form) this.form = data.form;
          if (data.model) this.model = data.model;
        })
        .catch(this.handleError)
        .finally(() => this.unsetLoading());
    },
    getVeiculos() {
      if (this.model.dataInicial && this.model.dataFinal) {
        this.setLoading();
        this.repositories.relatorioPrestacaoConta
          .getVeiculos({
            data_inicial: moment(this.model.dataInicial).format("Y-M-D"),
            data_final: moment(this.model.dataFinal).format("Y-M-D"),
          })
          .then(({ data }) => {
            this.form.veiculos = data;
            this.getMotoristas();
          })
          .catch(this.handleError)
          .finally(() => this.unsetLoading());
      }
    },
    getMotoristas() {
      this.model.motorista = null;
      if (this.model.dataInicial && this.model.dataFinal) {
        this.setLoading();
        this.repositories.relatorioPrestacaoConta
          .getMotoristas({
            data_inicial: moment(this.model.dataInicial).format("Y-M-D"),
            data_final: moment(this.model.dataFinal).format("Y-M-D"),
            veiculo: this.model.veiculo,
          })
          .then(({ data }) => {
            this.form.motoristas = data;
            this.getDestinos();
          })
          .catch(this.handleError)
          .finally(() => this.unsetLoading());
      }
      ("");
    },
    getDestinos() {
      this.model.destino = null;
      if (this.model.dataInicial && this.model.dataFinal) {
        this.setLoading();
        this.repositories.relatorioPrestacaoConta
          .getDestinos({
            data_inicial: moment(this.model.dataInicial).format("Y-M-D"),
            data_final: moment(this.model.dataFinal).format("Y-M-D"),
            motorista: this.model.motorista,
            veiculo: this.model.veiculo,
          })
          .then(({ data }) => {
            this.form.destinos = data;
          })
          .catch(this.handleError)
          .finally(() => this.unsetLoading());
      }
    },
    verificaDadoNulo(valor) {
      if (valor === null) return "-";
      return valor;
    },
    formatarBRL(valor) {
      if (!valor) {
        return this.verificaDadoNulo(valor);
      } else {
        return (
          "R$ " +
          parseFloat(valor).toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        );
      }
    },
    search() {
      this.$refs.RkmForm.validate()
        .then(valid => {
          if(!valid) return
          this.setLoading();
          this.repositories.relatorioPrestacaoConta
            .list({
              data_inicial: moment(this.model.dataInicial).format("Y-M-D"),
              data_final: moment(this.model.dataFinal).format("Y-M-D"),
              veiculo: this.model.veiculo,
              motorista: this.model.motorista,
              destino: this.model.destino,
            })
            .then(({ data }) => {
              this.items = data.consulta;
              this.totalizadores = data.totalizadores;
              this.mostraAreas = true;
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading());
        })
    },
    reset() {
      this.model.motorista = null;
      this.model.destino = null;
      this.model.veiculo = null;
      this.model.dataInicial = null;
      this.model.dataFinal = null;
      this.items = [];
      this.mostraAreas = false;
    },
    print() {
      this.setLoading();
      this.repositories.impressao
        .relatorioPrestacaoConta(this.prepareDataWithColumns())
        .then(({ data, headers }) =>
          this.openFile(data, headers["content-type"])
        )
        .catch(this.handleError)
        .finally(() => this.unsetLoading());
    },
    exportTo() {
      this.setLoading();
      this.repositories.exportacao
        .relatorioPrestacaoConta(this.prepareDataWithColumns())
        .then(({ data, headers }) =>
          this.openFile(data, headers["content-type"])
        )
        .catch(this.handleError)
        .finally(() => this.unsetLoading());
    },
    prepareDataWithColumns() {
      const data = this.prepareData();
      data.selectedCols = this.fields.map((f) => {
        return {
          key: this.camelToSnake(f.key),
          label: f.label,
          class: f.class,
          isCurrency: f.isCurrency || false,
        };
      });
      return data;
    },
    prepareData() {
      const data = this.clone(this.model);

      data.data = moment(this.model.data).format("Y-M-D");
      data.dataInicial = moment(this.model.dataInicial).format("Y-M-D");
      data.dataFinal = moment(this.model.dataFinal).format("Y-M-D");

      return this.camelObjectKeysToSnakeRecursive(data);
    },
    selectAll(selected) {
      this.selectedCols = selected
        ? this.optionalColumns.map((c) => c.key)
        : [];
    },
  },
  mixins: [repository, error, data, object, stringCase, file],
  watch: {
    selectedCols(newValue) {
      this.selectedAll =
        newValue.length > 0 && newValue.length == this.optionalColumns.length;
      this.indeterminate =
        newValue.length > 0 && newValue.length != this.optionalColumns.length;
    },
  },
};
</script>
